/**
 * @file aigc生图相关接口
 * @author zhanghaohan
 */
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import API from './api';
import originRequest from '../../../utils/request';
/**
 * 上传AIGC生成背景图
 * @returns Promise
 */
export const uploadAIGCBgImg = async params => {
    return request(
        API.UPLOAD_BG_IMG, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * AIGC生成图片 - 生成
 * @returns Promise
 */
export const createAIGCImage = async params => {
    return request(
        API.CREATE_AIGC_IMG, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * AIGC生成图片 - 获取风格列表
 * @returns Promise
 */
export const getAIGCImgMoodList = async params => {
    return request(
        API.GET_AIGC_IMG_MOOD_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * AIGC生成图片 - 首次抠图
 * @returns Promise
 */
export const clipInitAIGCImg = async params => {
    return request(
        API.CLIP_INIT_AIGC_IMG, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * AIGC生成图片 - 抠图
 * @returns Promise
 */
export const clipAIGCImage = async params => {
    return request(
        API.GET_AIGC_IMG_MOOD_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * AIGC生图 根据风格获取随机算子
 * @returns Promise
 */
export const getAIGCImgStyleIds = async params => {
    return request(
        API.GET_AIGC_IMG_STYLE_IDS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * AIGC生图 转存图片
 * @returns Promise
 */
export const uploadAIGCImg = async url => {
    const blob = await originRequest(url, {}, 'download');
    return request(
        API.SET_AIGC_IMG_UPLOAD, {
            method: 'POSTIMG',
            body: {
                file: blob
            }
        }
    );
};

/**
 * AIGC生图
 * @returns Promise
 */
export const transAIGCImg = async url => {
    return request(
        API.SET_AIGC_IMG_TRANS, {
            method: 'POSTJSON',
            body: {
                old_url: url
            }
        }
    );
};
